// Interface theme: colours of the app shell, not the 3D ride ambience (that one is a "theme" creation).
// A per-device preference kept outside the synced state: it works offline and never reaches the API.
import { THEME_BG, resolveTheme, savedTheme, type ThemeId } from '@gruvetto/browser';

export { THEMES, THEME_BG, isTheme, resolveTheme, type ThemeId, type ResolvedTheme } from '@gruvetto/browser';

const KEY = 'gv-theme';

type Store = Pick<Storage, 'getItem' | 'setItem'>;
const storage = (): Store | null => {
  try { return typeof localStorage === 'undefined' ? null : localStorage; } catch { return null; } // blocked storage throws on access
};

export const themePref = (store: Store | null = storage()): ThemeId => savedTheme(KEY, store);

const lightQuery = () => (typeof matchMedia === 'undefined' ? null : matchMedia('(prefers-color-scheme: light)'));

function apply(id: ThemeId) {
  if (typeof document === 'undefined') return;
  const resolved = resolveTheme(id, !!lightQuery()?.matches);
  document.documentElement.dataset.theme = resolved;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_BG[resolved]);
  document.dispatchEvent(new CustomEvent('gv:theme', { detail: resolved }));
}

export function setTheme(id: ThemeId, store: Store | null = storage()) {
  try { store?.setItem(KEY, id); } catch { /* storage unavailable: applies to this session only */ }
  apply(id);
}

/** Applies the saved theme and follows OS changes while "system" is selected. Call once, before the first render. */
export function startTheme() {
  apply(themePref());
  lightQuery()?.addEventListener('change', () => { if (themePref() === 'system') apply('system'); });
}
